import type { SxProps, Theme } from '@mui/material/styles'

export const borderedListContainerSx: SxProps<Theme> = {
    border: 1,
    borderColor: 'divider',
    borderRadius: 1,
    overflow: 'hidden',
    bgcolor: 'background.paper',
}

export const stripedListSx: SxProps<Theme> = {
    p: 0,
    overflow: 'hidden',
    bgcolor: 'background.paper',
    '& > .MuiListItem-root, & > .MuiListItemButton-root, & > .MuiListSubheader-root':
        {
            borderBottom: 1,
            borderColor: 'divider',
            borderRadius: 0,
        },
    '& > .MuiListItem-root, & > .MuiListItemButton-root': {
        px: 2.5,
        py: 1.5,
    },
    '& > .MuiListItem-root:last-child, & > .MuiListItemButton-root:last-child, & > .MuiListSubheader-root:last-child':
        {
            borderBottom: 0,
        },
}

export const stripedListSubheaderSx: SxProps<Theme> = {
    fontWeight: 700,
    lineHeight: 1.4,
    color: 'text.primary',
    bgcolor: 'background.paper',
    px: 2.5,
    py: 1.5,
}

type StripedListItemOptions = {
    striped?: boolean
}

export function stripedListItemSx(
    index: number,
    { striped = true }: StripedListItemOptions = {}
): SxProps<Theme> {
    return {
        ...(striped && index % 2 === 1 ? { bgcolor: 'grey.100' } : null),
        '&:hover': {
            bgcolor: 'grey.200',
        },
        '&.Mui-selected': {
            bgcolor: 'action.selected',
        },
        '&.Mui-selected:hover': {
            bgcolor: 'action.selected',
        },
    }
}
